import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  Button,
  Modal,
  Input,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import InfoView from '../../../components/common/InfoView';

import {
  addFdsCard,
  getFdsCards,
  updateFdsCard,
} from '../../../redux/actions/FdsCards';

import { FdsCardsColumns } from './Columns';
import FdsCardForm from './FdsCardForm';
import generateQuery, { handleSearch as search } from '../../../util/table';
import Can from '../../../util/can';
import { FDS_CARDS } from '../../../constants/resources';
import useForm from '../../../hooks/useForm';

const FdsCards = () => {
  const dispatch = useDispatch();
  const { timezone } = useSelector(({ settings }) => settings);

  const {
    data: fdsCardsData,
    loading,
    pageSize,
    currentPage,
    totalRecords,
  } = useSelector(({ fdsCards }) => fdsCards);

  const [searchParams, setSearchParams] = useState('');

  const {
    form,
    onFormOk,
    formVisibility,
    handleShowModal,
    handleCancel,
    handleEditRecord,
    editableRecord,
  } = useForm();

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getFdsCards(pagination));
  }, [dispatch]);

  const editable = Object.keys(editableRecord).length !== 0;

  const handleEditFdsCard = (record) => {
    handleShowModal();
    handleEditRecord(record);
    form.setFieldsValue({
      ...record,
    });
  };

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(getFdsCards(generateQuery(pagination, filters, sorter, searchParams)));
  };

  const handleSearch = (searchValue) => {
    const query = search(
      searchValue.trim().replace(/([^a-zA-Z0-9])/g, '\\$1'),
      dispatch, getFdsCards, FdsCardsColumns, timezone,
    );
    setSearchParams(query);
  };

  const props = {
    loading,
    pagination: {
      current: currentPage,
      pageSize,
      total: totalRecords,
      showSizeChanger: false,
    },
    onChange: handleOnChange,
    rowKey: '_id',
    columns: FdsCardsColumns(
      handleEditFdsCard,
      handleEditRecord,
    ),
    dataSource: fdsCardsData,
    scroll: { x: 1300 },
  };

  const handleCancelForm = () => {

  };

  const handleOk = (value) => {
    const fdsCardData = {
      ...value,
    };
    if (editable) {
      dispatch(updateFdsCard(editableRecord._id, fdsCardData));
    } else {
      dispatch(addFdsCard(fdsCardData));
    }
  };

  const handleChange = (value, key) => {
    form.setFieldsValue({
      [key]: value,
    });
  };

  return (
    (
      <div>
        <h2 className="title gx-mb-4">Fds Cards</h2>
        <div className="gx-d-flex justify-content-center">
          <Can I="create" a={FDS_CARDS}>
            <Button
              icon={<PlusOutlined />}
              type="primary"
              data-testid="add-transaction-charge-btn"
              onClick={() => handleShowModal()}
            >
              Add Fds Card
            </Button>

          </Can>
          <Input.Search
            data-testid="search-input"
            placeholder="Search fds cards"
            enterButton
            allowClear
            onSearch={handleSearch}
          />
        </div>
        <div className="gx-d-flex justify-content-center">
          <Table data-testid="fds-cards-table" className="gx-table-responsive" {...props} />
        </div>
        <Modal
          title={editable ? 'Edit Fds Card' : 'Add Fds Card'}
          open={formVisibility}
          okText={editable ? 'Save' : 'Add'}
          onOk={() => onFormOk(handleOk)}
          confirmLoading={loading}
          onCancel={() => {
            handleCancel();
            handleCancelForm();
          }}
          width={1000}
        >
          <FdsCardForm {...{
            form,
            handleChange,
          }}
          />
        </Modal>
        <InfoView />
      </div>
    )
  );
};

export default FdsCards;
